<template>
  <h2 class="logo">
    Track a <br>
    <span>Healthier Life</span>
  </h2>
</template>

<script>
export default {
  name: "Logo"
}
</script>

<style lang="sass" scoped>
.logo
  color: #ffffff
  text-align: left
  font-size: 1.75rem
  font-weight: 700
  margin: 0

  span
    color: #FE0000
    font-size: 2.5rem
    font-weight: 900
    line-height: 2.4rem
</style>
